<template>
  <vs-dropdown-item
    :to="`/meterreadingrequest/${action.parameters.token_id}`"
    class="flex justify-between py-4 notification cursor-pointer"
  >
    <relative-time-notification :date="action.date" />

    <div class="flex items-start">
      <div class="mx-2">
        <span
          class="font-medium block notification-title"
          :class="[`text-primary`]"
          >Meterstanden</span
        >
        <small>Het is weer tijd om je meterstanden in te vullen</small>
      </div>
    </div>
  </vs-dropdown-item>
</template>
<script>
import RelativeTimeNotification from "./RelativeTimeNotification.vue";
export default {
  components: { RelativeTimeNotification },
  props: ["action"]
};
</script>
